import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1e505018"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "ClothingStore"
};
var _hoisted_2 = {
  "class": "modal"
};
var _hoisted_3 = {
  "class": "gallery-container"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "StoreTitle"
  }, "Clothing Store", -1);
});
var _hoisted_5 = {
  "class": "items-grid"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = ["src", "alt"];
var _hoisted_8 = {
  "class": "pagination-controls"
};
var _hoisted_9 = {
  key: 0,
  "class": "showItem"
};
var _hoisted_10 = {
  "class": "modal-content"
};
var _hoisted_11 = ["src", "alt"];
var _hoisted_12 = {
  "class": "review-button__holder"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_Transition, {
    name: "fade"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.storeItems, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          "class": "item",
          key: index,
          onClick: function onClick($event) {
            return _ctx.selectItem(item);
          }
        }, [_createElementVNode("img", {
          src: item.image,
          alt: item.title
        }, null, 8, _hoisted_7)], 8, _hoisted_6);
      }), 128))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.previousPage && _ctx.previousPage.apply(_ctx, arguments);
        })
      }, "Prev"), _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = function () {
          return _ctx.nextPage && _ctx.nextPage.apply(_ctx, arguments);
        })
      }, "Next")]), _ctx.selectedItem ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
        "class": "largeImage",
        src: _ctx.selectedItem.image,
        alt: _ctx.selectedItem.title
      }, null, 8, _hoisted_11), _createElementVNode("h3", null, _toDisplayString(_ctx.selectedItem.title), 1), _createElementVNode("p", null, _toDisplayString(_ctx.selectedItem.description), 1), _createElementVNode("p", null, "Tokens: " + _toDisplayString(_ctx.selectedItem.numberOfTokens), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
        "class": "review-button",
        onClick: _cache[2] || (_cache[2] = function () {
          return _ctx.leaveReviewOnAppStore && _ctx.leaveReviewOnAppStore.apply(_ctx, arguments);
        })
      }, " Purchase ")]), _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = function () {
          return _ctx.closeModal && _ctx.closeModal.apply(_ctx, arguments);
        })
      }, "Close")])])) : _createCommentVNode("", true)])])];
    }),
    _: 1
  })]);
}